/* eslint-disable react/prop-types */
import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

const ProtectedRoute = ({ children }) => {
  const { loggedIn } = useSelector((state) => state.auth)
  if (!loggedIn) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default ProtectedRoute
